module.exports = new __parcel__URL__("rain.1d74adbc.jpg").toString();